module.exports = __webpack_public_path__ + "static/media/MileMarkerLunch.a04df198.pdf";